module.exports = __webpack_public_path__ + "static/media/1.381d0e80.JPG";